import { PayloadAction } from '@reduxjs/toolkit';
import { IClassRoomData } from '@/store/types';
import { createSliceSteamup } from '../common';

export type IssuedAccount = {
  uuid: string;
  name: string;
  email: string;
  profileAvatarUrl: string;
  isEnabled: boolean;
  createdAt: Date;
  lastActionAt?: Date;
  password?: string;
}

interface IIssueAccountModalState {
  createdClassRoomList: IClassRoomData[];
  selectedClassRoomUUID: string;
  accountList: IssuedAccount[];
  deleteList : string[];
  deleteLoading: boolean;
  addLoading: boolean;
}
const issueAccountModalSlice = createSliceSteamup(
  'issueAccountModal',
  {
    createdClassRoomList: [],
    selectedClassRoomUUID: '',
    accountList: [],
    deleteList: [],
    deleteLoading: false,
    addLoading: false,
  } as IIssueAccountModalState,
  {
    setCurrentClassRoomPrefix(state, { payload }: PayloadAction<string>) {
      const targetClassRoom = state.createdClassRoomList.find(({ uuid }) => uuid === state.selectedClassRoomUUID);
      if (!targetClassRoom) return;
      targetClassRoom.prefixAlias = payload;
    },
    setDeleteList(state, { payload }: PayloadAction<string[]>) {
      state.deleteList = payload;
    },
    pushNewAccount(state, { payload }: PayloadAction<IssuedAccount>) {
      state.accountList.push(payload);
    },

    setNewAccount(state, { payload }: PayloadAction<IssuedAccount[]>) {
      state.accountList = [...state.accountList, ...payload];
    },

    setAccountIsEnabled(state, { payload }: PayloadAction<{ uuid: string, isEnabled: boolean }>) {
      const target = state.accountList.find(({ uuid }) => uuid === payload.uuid);
      if (!target) return;
      target.isEnabled = payload.isEnabled;
    },

    setAccountName(state, { payload }: PayloadAction<{ uuid: string, name: string }>) {
      const target = state.accountList.find(({ uuid }) => uuid === payload.uuid);
      if (!target) return;
      target.name = payload.name;
    },

    setAccountPassword(state, { payload }: PayloadAction<{ uuid: string, password: string }>) {
      const target = state.accountList.find(({ uuid }) => uuid === payload.uuid);
      if (!target) return;
      target.password = payload.password;
    },

    setDeleteLoading(state, { payload }: PayloadAction<boolean>) {
      state.deleteLoading = payload;
    },

    setAddLoading(state, { payload }: PayloadAction<boolean>) {
      state.deleteLoading = payload;
    },
  },
);

export default issueAccountModalSlice;
